(function(){  var loadScript = function(url, callback){ var script = document.createElement("script"); script.type = "text/javascript"; if (script.readyState){ script.onreadystatechange = function(){ if (script.readyState == "loaded" || script.readyState == "complete"){  script.onreadystatechange = null;   callback(); } }; } else { script.onload = function(){ callback(); }; } script.src = url;  document.getElementsByTagName("head")[0].appendChild(script); }; var fix = function($){ var ml_lang;
  
  const observer_config = { attributes: true, childList: true, subtree: true };    
    
    
  var listen = false;

  window.ml_domains_local = {};
 

  function setCookie(v)
  {
    document.cookie = "redirected="+v+"; path=/;";
  }

  function delCookie()
  {
    document.cookie = "redirected=; path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC";
  }

  function getCookie() 
  {
      var name = "redirected=";
      var ca = document.cookie.split(';');
      for(var i = 0; i < ca.length; i++) 
      {
          var c = ca[i];
          while (c.charAt(0)==' ') 
              c = c.substring(1);
          
          if (c.indexOf(name) == 0) {   return c.substring(name.length,c.length);      }
      }
      return "";
  }
    
  function swap(json)
  {
      var ret = {};
      for(var key in json)
        ret[json[key]] = key;
  
      return ret;
  } 
    
  function getUrlVars()
  {   

    var vars = []; 
    var jvars = {};
    var hash;

    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    var cloc =  window.location.host; 
                  
      for(var i = 0; i < hashes.length; i++)
      {
          hash = hashes[i].split('=');
          if(hash[1]!=null) 
            jvars[hash[0]] = hash[1];
      }
      return jvars;
  }
  
  
  window.setAtt = function(target,reload=true)
  {

    $.post( '/cart/update.js' ,'attributes[ml_selected_language]='+target ,function(data){ console.log(data);}, 'json' );


    if ( window.location !== window.parent.location ) 
    {
      console.log('iFrame');
      return;
    }
    var host = location.host;

    var new_qs_arr = [];
    var new_qs = '';
    var qs = getUrlVars();
  
    for(var j=0; j< qs.length; j++)
    {
      if(qs[j]!='lang')
        new_qs_arr.push(qs[j]+'='+qs[qs[j]]);
    }
    new_qs = new_qs_arr.join('&');
    if(new_qs.length>0)
      new_qs = '?'+new_qs;
    var dest = '';

    var path = window.location.pathname;

      
        var san_path = '';
        var new_path = '';
        var re = new RegExp(root_path,"i");
        //get sanitized path
        if(!is_default_locale)
          san_path = path.replace(re,'');
        else
          san_path =  path;
      
        if(san_path =='')
          san_path ='/';

      
        if(target==def_loc)
          new_path = san_path;
        else 
            new_path = '/'+target+san_path;
          

      
    //var update_url = '';

    if(ml_domains_local[target]!=null)
    {
          host = ml_domains_local[target];
    }
        dest ='https://'+host+new_path+new_qs;  
    
        location.href = dest;
      
      return;       
      
        

  };  
  

  const inspectDOM = function(mutationsList, observer)
  {
    observer.disconnect();

    //interceptCartSubmit();
    
    if(typeof ml_opts === 'undefined' && typeof ml_frontend_replace  === 'undefined')
      return;
    
    if($('.single-option-selector-product').length || $('.single-option-selector').length || $('.single-option-radio').length || typeof ml_frontend_replace  != 'undefined')
    { 
      window.setTimeout(translateOptions,500);
      window.setTimeout(translateFrontendVars,500);
      window.setTimeout(attachDOMChangeListener,1000);
    }
  };
    
    const observer = new MutationObserver(inspectDOM);


  function attachDOMChangeListener()
  {
      observer.observe($('body').get(0), observer_config);

  }

  window.MLupdateProductOptions = function(){
    translateOptions();
  };

  window.MLtranslateFrontendVars = function(){
    translateFrontendVars();
  };

  function translateOptions()
  { 

    if(typeof ml_opt_names  === 'undefined')
      return;
    if(ml_opt_names==null)
            return;
    
    listen = true;
    $('.single-option-selector,.single-option-radio,.single-option-selector-product,.single-option-radio').each(function(){ 
      var par = $(this).closest('div:has(label)');  
      var opt_name = '';      
      opt_name = $('label',par).first().text();     
      opt_name = opt_name.trim();
      
            opt_name_md5 = hex_md5(opt_name);

      if(ml_opt_names[opt_name_md5])
      {                         
        $('label',par).first().text(ml_opt_names[opt_name_md5]);
        $('span.option-selector__label',par).first().text(ml_opt_names[opt_name_md5]+':');        
      }
            
      $('option,label,li',this).each(function(){

        var opt_val = $(this).html();
        opt_val = opt_val.trim();
              
                opt_val_md5 = hex_md5(opt_val);

        if(ml_opt_values[opt_val_md5])
          $(this).text(ml_opt_values[opt_val_md5]);

      });
      var st = $('option:selected',this).text();
      $('.selected-text',par).first().text(st);

    });

    /* custom option replacements */
    $('.ml_option,.ml_selected_option').each(function(){

      var opt_val = $(this).html();
      opt_val = opt_val.trim();
            opt_val_md5 = hex_md5(opt_val);

      if(ml_opt_values[opt_val_md5])
        $(this).text(ml_opt_values[opt_val_md5]);
    });
    
    $('.ml_opt_label').each(function(){
           
      var cust_opt_name = $(this).text().trim();
      var cust_opt_name_md5 = hex_md5(cust_opt_name);
      if(ml_opt_names[cust_opt_name_md5])
        $(this).text(ml_opt_names[cust_opt_name_md5]);

    });
    listen=false;
  }


  function translateFrontendVars(node)
  { 
    if(typeof ml_frontend_replace  === 'undefined')
      return;

    listen=true;
    if(node==null)
      node = document.body;

    var keys = Object.keys(ml_frontend_replace);
     
        var n = createTextNodeIterator(node);
        var keys = Object.keys(ml_frontend_replace);
       
        for(var i=0;i<n.length;i++)
        {
          var nv = n[i].nodeValue.trim().toLowerCase();
          for(var j=0;j < keys.length;j++)
            {
              var kv = keys[j].trim().toLowerCase();
              
                if(nv==kv)
                {
                  n[i].data =   ml_frontend_replace[keys[j]]; 
                }             
            }
        } 
      
    listen=false;
  }
  
  function createTextNodeIterator(textNode)
  {
      var textNodes = [];

      function getTextNodes(node) 
      {
          if (node.nodeType == 3) 
          {
                var pnn = node.parentNode.nodeName.toLowerCase();
                if(pnn=='style' || pnn =='script')
                  return;
            var txt = node.nodeValue.toLowerCase().trim();

              if(txt.trim()=='') 
                return;
              

                textNodes.push(node);
              
          } else 
          {
              for (var i = 0, len = node.childNodes.length; i < len; ++i)
                  getTextNodes(node.childNodes[i]);
            }
        }
      getTextNodes(textNode);
      return textNodes;
  } 


  

  function preloadImage(url)
  {
      var img=new Image();
      img.src=url;
  }
  
  $(document).ready( function()
  { 

        if(ml_redirect_mf=='once' || ml_redirect_mf=='force' )
        {
          var cookie = getCookie();
          var browser_lang_abbrev = window.navigator.language.substring(0,2);
          var current_locale_abbrev = current_locale.substring(0,2);
          var locale_keys = Object.keys(enabled_locales);

        
          if(browser_lang_abbrev!=current_locale_abbrev)
          {
            for(var i=0;i< locale_keys.length;i++)
            {
                var locale_abbrev = locale_keys[i].substring(0,2);
                
                if(locale_abbrev == browser_lang_abbrev)
                {
                    if( ml_redirect_mf=='force' )
                    {
                        setCookie('force');
                        setAtt(locale_keys[i]); 
                        return;
                    }
                    else if( ml_redirect_mf=='once' )
                    {
                        if(cookie=='')
                        {
                            setCookie('once');
                            setAtt(locale_keys[i]); 
                            return;                        
                        }
                    }
                }
            }
          }            
          else    
          {
            setCookie('once');
          }   
      }

        
    var bidi = ['ar','fa','ur','he','he-IL']; 
    if( bidi.indexOf(current_locale)>=0  && (ml_rtl == 'rtl'))
    {
      $('body').css('direction','rtl');
      $('body').addClass('rtl');
    } 
    else
    {
      $('body').css('direction','');
      $('body').removeClass('rtl');
    }   
    ml_domains_local = ml_domains_mf; 

        if(ml_domains_local[current_locale]!=null)
        {
          var assigned_host = ml_domains_local[current_locale];
            var current_host = location.host;
            assigned_host = assigned_host.replace('www.', '');
            current_host = current_host.replace('www.', '');
            if(assigned_host!= current_host)
              setAtt(current_locale);  
        }

    $('.ml_switch_loc,.ml_custom_switch').change(function(){
      var v= $(this).val();
      setAtt(v);
    });
    
    $('.ml_link').click(function(){ 
      var v = '';
      if($(this).attr('lang_id'))
        var v =$(this).attr('lang_id');
      else
        v = $(this).attr('id');
      setAtt(v);
    });
  
    $('.lang_tab').click(function()
    {        
      var sl = $(this).attr('value');
      setAtt(sl);

    });   


    $('.ml_lang_selector .ml_button').click(function()
    {      
      $('.ml_lang_selector ul li').slideToggle();  
    });  

        $(document).mouseup(function(e) 
      {
          var sel = $('.ml_lang_selector');
          if (!sel.is(e.target) && sel.has(e.target).length === 0) 
          {
              $('.ml_lang_selector ul li').slideUp();
          }
      });   

    attachDOMChangeListener(); 

});
};if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {loadScript("//cdnjs.cloudflare.com/ajax/libs/jquery/3.2.1/jquery.min.js", function(){ jQuery191 = jQuery.noConflict(true);fix(jQuery191);});} else {fix(jQuery);}})();